"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsDateToday = void 0;
const date_fns_1 = require("date-fns");
const checkIsDateToday = (date) => {
    return (0, date_fns_1.isToday)(new Date(date));
};
exports.checkIsDateToday = checkIsDateToday;
